import { HttpClient } from '@angular/common/http';
import { Inject, inject, Injectable } from '@angular/core';

import { PROTECTED_API_URL } from '@lib/core/tokens/api.tokens';

@Injectable()
export class TasksCountService {
  private readonly http = inject(HttpClient);
  private readonly protectedApiUrl: string;

  constructor(@Inject(PROTECTED_API_URL) protectedApiUrl: string) {
    this.protectedApiUrl = protectedApiUrl;
  }

  getNewTasksCount() {
    return this.http.get<number>(`${this.protectedApiUrl}/actions/new/count`);
  }
}
